import { Component } from '@angular/core';
import { LocaleService } from '../shared/services/locale.service';
import { ViewportService } from '../shared/services/viewport.service';
import { AmplitudeService } from 'src/app/core/services/amplitude.service';

@Component({
	selector: 'app-inner-footer',
	templateUrl: './inner-footer.component.html',
	styleUrls: ['./inner-footer.component.scss'],
})
export class InnerFooterComponent {
	constructor(public locale: LocaleService, public viewport: ViewportService, private amplitude: AmplitudeService) {}

	onClickShortcuts(): void {
		this.amplitude.trackShortcuts();
	}
}
